/// <reference path="../global.d.ts" />
/// <reference path="../Helpers.ts" />
/// <reference path="../Modal.ts" />
/// <reference path="../ModalForm.ts" />
/// <reference path="../UI/Snackbar.ts" />



namespace MACRAIL.UI {

/**
 * Manage screens.
 */
export class Screens {

    /**
     * @var number Time the last Screen was opened.
     */
    public static lastShowTime: number = 0;

    /**
     * Show a screen
     *
     * @param screen Path to screen.
     * @param data  Data to pass as POST.
     */
    public static show(screen: string, data: any = {}, opts: any = {}): void {

        let time = (new Date()).getTime();
        let lastTime = Screens.lastShowTime;

        Screens.lastShowTime = time;

        if (lastTime > time - 1000) {
            // tslint:disable-next-line:no-console
            console.info('Blocked opening a second screen too quickly.');
            return;
        }

        let url = Screens.urlForScreen('show', screen);

        let errorMessage = 'There was an error opening that screen.';

        $.post(url, data)
        .done(function(response) {
            if (typeof response !== 'object') {
                MACRAIL.UI.Snackbar.show('danger', errorMessage);
                return;
            }

            if (response.status && response.status === 'error') {
                MACRAIL.UI.Snackbar.show('danger', response.message || errorMessage);
                return;
            }

            if (!response.forceOpen && $('body').hasClass('modal-open')) {
                // tslint:disable-next-line:no-console
                console.info('Blocked opening a screen because a modal dialog is already open.');
                return;
            }

            let modal = new MACRAIL.Modal(response);

            if (opts.onClose) {
                modal.setOption('onHide', function() {
                    opts.onClose();
                });
            }

            GLOBALS.currentModal = modal;
            modal.show();
        })
        .fail(function() {
            MACRAIL.UI.Snackbar.show('danger', errorMessage);
        });
    }

    public static postToAction(screen: string, action: string, data: any = {}) {
        let url = Screens.urlForScreen('postToAction', screen);

        data._action = action;

        return $.post(url, data);
    }

    public static postForm(screen: string, form: MACRAIL.Forms.Form) {
        let url = Screens.urlForScreen('postForm', screen);

        let data = form.getValues();

        return $.post(url, data);
    }

    private static urlForScreen(task: string, screen: string) {
        let url = MACRAIL.Helpers.makeUrl({
            'controller': 'comScreen',
            'action': '_' + task,
            'item': screen,
            'params': {
                '_specialpage': 'nohtml',
            },
        });

        return url;
    }
}

}
